module.exports = __webpack_public_path__ + "img/illustrative-kiln-matrix 2.5061fced.svg";